<template>
  <div class="header">
    <div class="left-logo-box float-left cursorPointer" @click="toOverFlow">
      <img src="@/assets/new-image/header/new_logo2.png" />
    </div>
    <div class="first-menu-box float-left flexc-cen-x">
      <div
        :class="['first-menu-item' ,'cursorPointer' , topActive == index ? 'active':'']"
        :key="item.name"
        v-for="(item, index) in nowFirstList"
        @click="toPage(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right-content-box float-right flexc-cen-x ">
      <!-- 联系我们 -->
      <contactInformation />
      <!-- 头像组件 -->
      <cursorPointer />
    </div>
  </div>
</template>

<script>
import contactInformation from "./prop/contactInformation.vue";
import cursorPointer from "./prop/cursorPointer.vue";
export default {
  name: "Header",
  components: {
    contactInformation,
    cursorPointer,
  },
  data() {
    return {
      topActive: 0,
    }
  },
  computed: {
    nowFirstList() {
      let arr = [];
      arr = this.$store.state.fistMenuList.filter(item=>item.name != "系统设置");
      return arr;
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newval, oldval) {
        // 如果刷新页面
        if (!oldval) {
          let pathArr = newval.path.split("/");
          let nowFirstList = this.nowFirstList;
          let ind = 0;
          nowFirstList.forEach((item, index) => {
            if (item.path == "/" + pathArr[1]) {
              ind = index;
            }
          });
          // 默认选中的样式topActive
          this.topActive = ind;
        }
      },
    },
  },
  methods: {
    // 去中台页
    toOverFlow() {
      // if (
      //   window.location.href.indexOf("test") > -1 ||
      //   window.location.href.indexOf("localhost") > -1
      // ) {
      //   location.href = "https://yunzhoutest.yucrm.cn/overflow";
      // } else {
      //   location.href = "https://yz.yqcrm.cn/overflow";
      // }
      location.href =
        "/api/yunzhou-common/system-redirect?redirectUrl=/overflow";
    },
    // 去店铺授权
    toShop() {
      let path = "";
      if (
        window.location.href.indexOf("test") > -1 ||
        window.location.href.indexOf("localhost") > -1
      ) {
        path = "https://yunzhoutest.yucrm.cn/shop";
      } else {
        path = "https://yz.yqcrm.cn/shop";
      }
      window.open(path, "_blank");
    },
    toPage(item, index) {
      if (item.name == "系统设置") {
        // this.toShop();
        window.open(item.path, "_blank");
        return;
      } else {
        let path, childMenuData;
        childMenuData = this.$store.state.childMenuList[index][0];
        path = item.path + this.checkMenu(childMenuData);
        // console.log(path);
        this.$store.state.fistActIndex = index;
        this.$router.push(path);
      }
    },
    // 检查栏目拼接请求地址-menuType是M代表栏目，C代表页面
    checkMenu(dataObj) {
      let path = "";
      if (dataObj.menuType == "M" && !!dataObj.children) {
        let childrenPath = dataObj.children[0].path;
        path = dataObj.path + childrenPath;
        return path;
      } else {
        return dataObj.path;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>